import React from 'react'
import { createSelector } from 'reselect'
import { I18n } from 'react-redux-i18n'
import _ from 'lodash'

import parametersSelector from 'selectors/parameters'

const referralsSelector = state => state.users.current.referral_users

const referral_status = ({ bounty_amount, confirmed_at }) =>
  bounty_amount > 0 ? 'Tokenholder' : confirmed_at ? 'Confirmed' : 'Registration incomplete'

const referral_balance_status = ({ bounty_amount, confirmed_at }) =>
  bounty_amount > 0 ? 'Active Referral' : confirmed_at ? 'Confirmed' : 'Registration incomplete'

const currency_format = (amount, currency) => `${amount} ${currency}`

const getColumns = config_parameters => {
  const tokens = config_parameters['user.referral_bonus_type'] === 'tokens'
  const status = tokens ? referral_status : referral_balance_status
  const columns = [
    {
      Header: 'User',
      accessor: 'email'
    },
    tokens
      ? {
          Header: 'Tokens',
          accessor: 'bounty_amount',
          Cell: row => row.value || 0
        }
      : {
          Header: 'Amount',
          accessor: 'currencies',
          Cell: row =>
            _.map(row.value, (amount, currency) => [
              currency_format(amount, currency),
              <br key={currency} />
            ])
        },
    {
      Header: 'Registration Date',
      accessor: 'created_at_formatted'
    },
    {
      Header: 'Status',
      id: 'status',
      accessor: row => row,
      Cell: row => status(row.value)
    }
  ]

  if (config_parameters['referral.percent_to_referrer'].length > 1)
    return [
      ...columns,
      {
        Header: 'Level',
        accessor: 'referral_level'
      }
    ]

  return columns
}

export default createSelector(
  parametersSelector,
  referralsSelector,
  (config_parameters, { json, headers, loading, search }) => ({
    search,
    total: (headers && parseInt(headers.get('x-total'), 10)) || 0,
    loading,
    defaultSorted: [{ id: 'date', desc: true }],
    defaultPageSize: search.per_page,
    pages: headers && Math.ceil(headers.get('x-total') / headers.get('x-per-page')),
    columns: getColumns(config_parameters),
    data: _.map(json, referral => ({
      ...referral,
      created_at_formatted: I18n.l(referral.created_at, { dateFormat: 'date.referrals' })
    }))
  })
)



// WEBPACK FOOTER //
// ./src/selectors/referrals.js